import { useCallback, useMemo, useState, useEffect } from 'react';
import xSpeedCacheEnterpriseImg from './assets/xspeedcache-enterprise.svg';

export function XspeedEnterpriceCard({
	index,
	id,
	cartData,
	addToCart,
	removeFromCart,
}) {
	const xSpeedCacheEnterprise = useMemo(() => {
		if (!cartData) {
			return null;
		}

		const _cartData = cartData.details.map((i, idx) => ({
			...i,
			index: idx,
		}));

		return _cartData?.find(item => +item.id === +id) ?? null;
	}, [cartData]);

	const [priceId, setPriceId] = useState(1);
	const [typeYearly, setTypeYearly] = useState(1);
	const [checked, setChecked] = useState(
		xSpeedCacheEnterprise ? true : false
	);

	useEffect(() => {
		let priceId = xSpeedCacheEnterprise?.item_number?.options?.price_id;
		if (xSpeedCacheEnterprise && priceId) {
			setTypeYearly(+priceId);
			setPriceId(+priceId);
		}
	}, [xSpeedCacheEnterprise]);

	const addProductInCart = useCallback(
		(priceId, action = false) => {
			let product = {
				download_id: id,
				price_id: priceId,
			};

			if (action) {
				product.action = 'update';
			}

			addToCart(product, true, false);
		},
		[addToCart]
	);

	useEffect(() => {
		if (checked && xSpeedCacheEnterprise === null) {
			addProductInCart(typeYearly);
		} else if (
			!checked &&
			xSpeedCacheEnterprise &&
			xSpeedCacheEnterprise?.index
		) {
			removeFromCart(xSpeedCacheEnterprise?.index);
		}
	}, [checked, typeYearly]);

	useEffect(() => {
		if (xSpeedCacheEnterprise && typeYearly !== +priceId) {
			addProductInCart(typeYearly, true);
		}
	}, [typeYearly, xSpeedCacheEnterprise]);

	useEffect(() => {
		if (xSpeedCacheEnterprise == null) {
			setChecked(false);
		}
	}, [xSpeedCacheEnterprise]);

	return (
		<>
			<form>
				<label
					htmlFor={`addToItemAi` + index}
					className="wp-checkout-flex wp-checkout-flex-space-between wp-checkout-aiCard "
				>
					<div className="wp-checkout-flex wp-checkout-flex-center wp-checkout-card-left-content">
						<div className="wp-checkout-aiCard-add">
							<input
								type="checkbox"
								checked={checked}
								onChange={() => setChecked(checked => !checked)}
								id={`addToItemAi` + index}
							/>
							<label
								htmlFor={`addToItemAi` + index}
								className="aiCard-add-checkbox"
							></label>
						</div>
						<div className="wp-checkout-aiCard-logo">
							<img src={xSpeedCacheEnterpriseImg} />
						</div>
						<div className="wp-checkout-aiCard-header">
							<h3 className="wp-checkout-font-lg aiCard-header">
								xSpeed Cloudflare Enterprise
							</h3>
							<p className="wp-checkout-font-sm aiCard-sub-header">
								Monthly Plan
							</p>
						</div>
					</div>
					<div className="wp-checkout-flex wp-checkout-flex-center wp-checkout-card-right-content">
						<h3 className="wp-checkout-font-lg wp-checkout-product-price">
							$5.00
						</h3>
					</div>
				</label>
			</form>
		</>
	);
}
